var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.71 10.29L18.71 9.29L18 9V5L17.71 4.29L14.71 1.29L14 1H10L9.29 1.29L6.29 4.29L6 5V9L5.29 9.29L4.29 10.29L4 11V19L4.29 19.71L7.29 22.71L8 23H16L16.71 22.71L19.71 19.71L20 19V11L19.71 10.29ZM8 5.41L10.41 3H13.58L15.99 5.41V9H7.99V5.41H8ZM18 18.58L15.59 20.99H8.42L6.01 18.58V11.41L6.42 11H17.59L18 11.41V18.58ZM13 12.99L14 13.99V15.99L13 16.99V18.99H11V16.99L10 15.99V13.99L11 12.99H13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/1772534745/media/icon-lock.c19b557fd66ae2f9e482989a1a56b853.svg";
export { ForwardRef as ReactComponent };